import { addQueryString } from 'utils/addQueryString'
import { ErrorResponse } from '../types'
import { request } from '../utils'
import { PATH } from './constants'
import {
  FutureBookingsResponse,
  CarRentalDaysResponse,
  RevenuePerDayResponse,
  RevenuePerUnitResponse,
  IGetCommonProps,
  IGetFutureBookingsProps,
  VolumesResponse,
  RevenueResponse,
  ReservationScheduleResponse,
  RevenuePerCarClassResponse,
} from './types'
import { EnvironmentVariablesService } from 'utils/env'

class Api {
  public baseUrl = EnvironmentVariablesService.getEnv('REACT_APP_API_URL') || ''

  async getCarRentalDays({
    companyId = '',
    dateStart = '',
    dateEnd = '',
  }: IGetCommonProps) {
    return request<CarRentalDaysResponse, ErrorResponse>(
      this.baseUrl,
      addQueryString(PATH.RENTAL_DAYS, { companyId, dateStart, dateEnd }),
      { method: 'GET' }
    )
  }

  async getFutureBookings({
    companyId = '',
    locationId = '',
    dateStart = '',
    dateEnd = '',
  }: IGetFutureBookingsProps) {
    return request<FutureBookingsResponse, ErrorResponse>(
      this.baseUrl,
      addQueryString(PATH.FUTURE_BOOKING, {
        companyId,
        locationId,
        dateStart,
        dateEnd,
      }),
      { method: 'GET' }
    )
  }

  async getRevenuePerDay({
    companyId = '',
    dateStart = '',
    dateEnd = '',
  }: IGetCommonProps) {
    return request<RevenuePerDayResponse, ErrorResponse>(
      this.baseUrl,
      addQueryString(PATH.REVENUE_PER_DAY, {
        companyId,
        dateStart,
        dateEnd,
      }),
      { method: 'GET' }
    )
  }

  async getRevenuePerUnit({
    companyId = '',
    dateStart = '',
    dateEnd = '',
  }: IGetCommonProps) {
    return request<RevenuePerUnitResponse, ErrorResponse>(
      this.baseUrl,
      addQueryString(PATH.REVENUE_PER_UNIT, {
        companyId,
        dateStart,
        dateEnd,
      }),
      { method: 'GET' }
    )
  }

  async getVolumes({
    companyId = '',
    dateStart = '',
    dateEnd = '',
    carCategories = [],
  }: IGetCommonProps) {
    return request<VolumesResponse, ErrorResponse>(
      this.baseUrl,
      addQueryString(PATH.VOLUMES, {
        companyId,
        dateStart,
        dateEnd,
        carCategories,
      }),
      { method: 'GET' }
    )
  }

  async getRevenue({
    companyId = '',
    dateStart = '',
    dateEnd = '',
    carCategories = [],
  }: IGetCommonProps) {
    return request<RevenueResponse, ErrorResponse>(
      this.baseUrl,
      addQueryString(PATH.REVENUE, {
        companyId,
        dateStart,
        dateEnd,
        carCategories,
      }),
      { method: 'GET' }
    )
  }

  async getReservationSchedule({
    companyId = '',
    dateStart = '',
    dateEnd = '',
    carCategories = [],
    timeGrain = '',
  }: IGetCommonProps) {
    return request<ReservationScheduleResponse, ErrorResponse>(
      this.baseUrl,
      addQueryString(PATH.RESERVATION_SCHEDULE, {
        companyId,
        dateStart,
        dateEnd,
        carCategories,
        timeGrain,
      })
    )
  }

  async getRevenuePerCarClass({
    companyId = '',
    dateStart = '',
    dateEnd = '',
    carCategories = [],
    timeGrain = '',
  }: IGetCommonProps) {
    return request<RevenuePerCarClassResponse, ErrorResponse>(
      this.baseUrl,
      addQueryString(PATH.REVENUE_PER_CAR_CLASS, {
        companyId,
        dateStart,
        dateEnd,
        carCategories,
        timeGrain,
      })
    )
  }

  async getRevenuePerCar({
    companyId = '',
    dateStart = '',
    dateEnd = '',
    carCategories = [],
  }: IGetCommonProps) {
    return request<RevenuePerCarClassResponse, ErrorResponse>(
      this.baseUrl,
      addQueryString(PATH.REVENUE_PER_CAR, {
        companyId,
        dateStart,
        dateEnd,
        carCategories,
      })
    )
  }
}

export const dashboardApi = new Api()
